
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import IfComp from '../common/IfComp';
import SelectOpsub from '../common/iskn/SelectOpsub';
import OverviewPanel from '../projectOverviewPage/OverviewPanel';
import IsknDataComboBox from '../common/IsknDataComboBox';

import AnalyzeDefunctParResult from './AnalyzeDefunctParResult';

const classNames = mergeStyleSets({
    AnalyzeDefunctParView: {
        paddingLeft: 16,
        paddingRight: 16,
        //border: '1px solid red'
    },
    analyzeButton: {
        //paddingTop: 8
    }
});

const AnalyzeDefunctParView = ({
    analyzeData,
    canAnalyze,
    isAnalyzeLoading,
    isAnalyzeLoaded,
    isOpsubActualLoaded,
    isknDate,
    opsubItem,
    opsubItems,
    onClickAnalyze,
    onChangeOpsub,
    onChangeIsknDate
}) => {

    return (
        <Stack className={classNames.AnalyzeDefunctParView} verticalFill tokens={{childrenGap: 16}}>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <OverviewPanel title="VÝBĚR AKTUÁLNÍHO VLASTNÍKA" loaded={isOpsubActualLoaded} panelWidth="500px">
                        <SelectOpsub
                            opsubItem={opsubItem}
                            opsubItems={opsubItems}
                            onChange={onChangeOpsub}
                        />
                    </OverviewPanel>
                    <OverviewPanel title="VÝBĚR DATOVÉ SADY ISKN" loaded={true} panelWidth="500px">
                        <IsknDataComboBox
                            isknDate={isknDate}
                            onChange={onChangeIsknDate}
                        />
                    </OverviewPanel>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal>
                    <Stack.Item className={classNames.analyzeButton}>
                        <PrimaryButton
                            disabled={!canAnalyze || isAnalyzeLoading}
                            text="Analyzovat zaniklé parcely"
                            onClick={onClickAnalyze}
                        />
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item grow>
                <IfComp cond={isAnalyzeLoading || isAnalyzeLoaded}>
                    <AnalyzeDefunctParResult
                        data={analyzeData}
                        isLoaded={isAnalyzeLoaded}
                    />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default AnalyzeDefunctParView;
